import IndexedDb from '../IndexedDb';
import { getGroupData } from '../Chat/Group';
import { getCallDisplayDetailsForOnetoManyCall } from '../Call/Call';
import { constructRosterData } from '../Chat/User';
import { shouldHideNotification } from '../Utility';
import { store } from '../../Redux/store';
import { GroupChatAvatarImg, SingleChatAvatarImg } from '../../assets/images';
import { getFromLocalStorageAndDecrypt } from '../Chat/webChatEncryptDecrypt';
import { addBrowserNotify } from '../../Redux/feature/browserNotifySlice';

const getGroupDetails = (groupId) => {
    let rosterData = {};
    let group = getGroupData(groupId);
    rosterData.displayName = group.groupName;
    rosterData.image = group.groupImage;
    rosterData.jid = group.groupId;
    rosterData.chatType = "groupchat";
    return rosterData;
}

        
const Push  = require("push.js");

const browserNotify = {
    timeOut: 8000,
    isPageHidden: false,
    init: function(){
        Push.Permission.request(() => {}, () => {});
        document.addEventListener(
            "visibilitychange",
            () => {
              browserNotify.isPageHidden = document.hidden;
            },
            false
          );
    },
    hasPermission: function(){
        const webSettings = getFromLocalStorageAndDecrypt('websettings')
        let parseredWebSettings = webSettings ? JSON.parse(webSettings) : {}
        const { Notifications = true } = parseredWebSettings;
        return Notifications && Push.Permission.has();
    },
    hasPermissionForCall: function(){
        const browserTab = store.getState().browserTab;
        return !browserTab.data && browserNotify.hasPermission();
    },
    sendCallNotification: async function(callDetailObj){
        if(!browserNotify.hasPermissionForCall()) return;
        let rosterData = {};
        let user = "";
        let displayName = "";
        if(callDetailObj.callMode === "onetoone"){
            user = callDetailObj.to;
            let userJid = user.includes("@") ? user.split('@')[0] : user;
            rosterData = await constructRosterData(userJid);
            displayName = rosterData.nickName;
        } else if(callDetailObj.callMode === "onetomany"){
            if(callDetailObj.groupId !== null && callDetailObj.groupId !== undefined){
                user = callDetailObj.groupId.includes("@") ? callDetailObj.groupId.split('@')[0] : callDetailObj.groupId
                rosterData = await constructRosterData(user);
                displayName = rosterData.displayName;
            } else {
                let userList = callDetailObj.userList.split(",");
                rosterData = getCallDisplayDetailsForOnetoManyCall(userList);
                displayName = rosterData.displayName;                
            }
        }
        if(!rosterData) return;
        let title = null;
        let pageName = null;
        const isGroupCall = callDetailObj.callMode === 'onetomany';

        if(callDetailObj.status === "calling"){
            pageName = 'calleescreen';
            title = `Incoming ${isGroupCall ? 'group' : ''} ${callDetailObj.callType} call`;
            if (shouldHideNotification() && browserNotify.isPageHidden) {
                displayName = "New Incoming Call";
            }
        }
        else if(callDetailObj.status === "ended"){
            pageName = 'calllog';
            title = `You missed ${!isGroupCall && callDetailObj.callType === "audio" ? "an" : "a" }${isGroupCall ? ' group' : ''} ${callDetailObj.callType} call`;
            if (shouldHideNotification() && browserNotify.isPageHidden) {
                displayName = "New Missed Call";
            }
        }

        if(!title) return;

        let notifyBody = {
            body: displayName,
            onClick: function(){
                // Reset the browser notify store
                store.dispatch(addBrowserNotify())
                store.dispatch(addBrowserNotify(pageName))
                window.focus();
                // // close();
            }
        }
        if(rosterData.image || rosterData.image === "" || rosterData.chatType === 'groupchat'){
            let image = rosterData.thumbImage !== "" ? rosterData.thumbImage : rosterData.image;
            const localDb = new IndexedDb();
            if(Array.isArray(image)){
                image = image[0];
            }
            localDb.getImageByKey(image, 'profileimages').then(blob => {
                const blobUrl = window.URL.createObjectURL(blob);
                browserNotify.sendNotification(title, {...notifyBody, icon: blobUrl});
            }).catch(err => {
                const avatarImage = callDetailObj.callMode === 'onetomany' ? GroupChatAvatarImg : SingleChatAvatarImg;
                browserNotify.sendNotification(title, {...notifyBody, icon: avatarImage});
            })
            return;
        }

        browserNotify.sendNotification(title, notifyBody);
    },
    sendNotification: function(title, bodyObj = {}){
        if(!title) return;
        const webSettings = getFromLocalStorageAndDecrypt('websettings')
        let parseredWebSettings = webSettings ? JSON.parse(webSettings) : {}
        const { Sound = false } = parseredWebSettings;
        bodyObj = {...bodyObj, timeout: browserNotify.timeOut, silent:Sound};
        Push.create(title, bodyObj);
    }
}

export default browserNotify;
